import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { CoreConfigService } from '@core/services/config.service';
import { Store } from '@ngrx/store';
import { AuthHelperService } from 'app/auth/helpers/auth-helper.service';
import { AuthenticationService } from 'app/auth/service';
import { AuthFacade } from 'app/store/auth.facade';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreConfig } from '../../../../../@core/types';
import { UserRegistrationValidators } from '../form-validatation';

@Component({
  selector: 'app-auth-register',
  templateUrl: './auth-register.component.html',
  styleUrls: ['./auth-register.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AuthRegisterComponent implements OnInit, OnDestroy {
  // Public
  public coreConfig: CoreConfig;
  public passwordTextType: boolean;
  public registerForm: UntypedFormGroup;
  public submitted = false;
  public loading = false;
  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   * @param toasatr
   * @param authenticationService
   * @param _router
   * @param authHelpder
   * @param _authFacade$
   * @param _store
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private toasatr: ToastrService,
    private authenticationService: AuthenticationService,
    private _router: Router,
    private authHelpder: AuthHelperService,
    private _authFacade$: AuthFacade,
    private _store: Store
  ) {
    this._unsubscribeAll = new Subject<void>();

    // Configure the layout
    this._coreConfigService.setConfig({
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    });
  }

  // convenience getter for easy access to form fields
  get form() {
    return this.registerForm.controls;
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    this.loading = true;
    this.authenticationService.doRegister(this.registerForm.value)
      .subscribe({
        next: (register) => {
          this.authHelpder.setLayoutConfig(false, true, true);
          this.loading = false;
          this._router.navigate(['/email-confirm']);
        }, error: (error: string) => {
          this.loading = false;
          this.toasatr.error(error, 'register failed', { toastClass: 'toast ngx-toastr', closeButton: true });
        }
      });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.registerForm = this._formBuilder.group({
      firstName: ['', UserRegistrationValidators.name],
      lastName: ['', UserRegistrationValidators.name],
      email: ['', UserRegistrationValidators.email],
      password: ['', UserRegistrationValidators.password],
      terms: [false, UserRegistrationValidators.terms],
    });

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}